import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, X } from 'lucide-react';

export function BetaBadge() {
  return (
    <div className="flex justify-center py-3 flex-shrink-0 group relative" data-testid="beta-badge">
      <span className="text-[9px] font-bold tracking-[0.25em] uppercase text-muted-foreground/25 border border-white/[0.06] rounded-full px-3 py-1 animate-pulse select-none cursor-default">
        beta
      </span>
      <div className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
        <div className="bg-bg-paper border border-white/10 rounded-lg px-3 py-1.5 shadow-xl whitespace-nowrap">
          <p className="text-[10px] text-muted-foreground">Features & experience subject to change</p>
        </div>
      </div>
    </div>
  );
}

export default function PageShell({ title, children, showBack = true }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-start justify-center px-4 py-8 md:py-12 relative z-10">
      <div className="w-full max-w-md bg-bg-paper/95 backdrop-blur-xl rounded-3xl border border-white/10 shadow-2xl overflow-hidden min-h-[85vh] max-h-[90vh] flex flex-col" data-testid="page-shell">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/5">
          {showBack ? (
            <button
              data-testid="page-back-btn"
              onClick={() => navigate(-1)}
              className="p-1.5 hover:bg-white/10 rounded-full transition-colors"
            >
              <ChevronLeft className="w-5 h-5 text-muted-foreground" />
            </button>
          ) : <div className="w-8" />}
          <h2 className="font-heading text-base font-semibold">{title}</h2>
          <button
            data-testid="page-close-btn"
            onClick={() => navigate('/home')}
            className="p-1.5 hover:bg-white/10 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-muted-foreground" />
          </button>
        </div>
        {/* Content */}
        <div className="flex-1 overflow-y-auto">
          {children}
        </div>
        <BetaBadge />
      </div>
    </div>
  );
}
